var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',[_c('template',{slot:"content"},[(_vm.loading)?_c('div',{staticClass:"relative py-12"},[_c('v-spa-loader')],1):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }